import React from "react";
import Helmet from "react-helmet";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CookieConsent from "react-cookie-consent";
import { useLocation } from "@reach/router";
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";
import { graphql, useStaticQuery } from "gatsby";

const Layout = ({ title, page, children }) => {
	const location = useLocation();
	const data = useStaticQuery(graphql`
		{
			site {
				siteMetadata {
					description
					siteUrl
					title
				}
			}
			wp {
				themeGeneralSettings {
					globalOptions {
						cookieBanner {
							content
							acceptButton
						}
					}
				}
			}
		}
	`);
	const cookieText = data.wp.themeGeneralSettings.globalOptions.cookieBanner.content;
	const cookieButtonText = data.wp.themeGeneralSettings.globalOptions.cookieBanner.acceptButton || "I understand";

	return (
		<>
			<Helmet
				title={`${data.site.siteMetadata.title} | ${title}`}
				defer={false}
				htmlAttributes={{
					lang: "en",
				}}
			>
				<meta
					name="description"
					content={data.site.siteMetadata.description}
				/>
				{/* Hotjar Tracking Code for Old Dalby website */}
				<script>
					{`
						(function(h,o,t,j,a,r){
							h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
							h._hjSettings={hjid:6746504,hjsv:6};
							a=o.getElementsByTagName('head')[0];
							r=o.createElement('script');r.async=1;
							r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
							a.appendChild(r);
						})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
					`}
				</script>
				{/* Google Tracking Script */}
				<script async src="https://www.googletagmanager.com/gtag/js?id=G-NM5DYXRRM8"></script>
				<script>
					{`
						window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-NM5DYXRRM8');
					`}
				</script>
				{/* LinkedIn Script */}
				<script type="text/javascript">
					{`
						_linkedin_partner_id = "10534169";
						window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
						window._linkedin_data_partner_ids.push(_linkedin_partner_id);
					`}
				</script>
				<script type="text/javascript">
					{`
						(function(l) {
							if (!l){window.lintrk = function (a, b) { window.lintrk.q.push([a, b]) };
							window.lintrk.q=[]}
							var s = document.getElementsByTagName("script")[0];
							var b = document.createElement("script");
							b.type = "text/javascript";b.async = true;
							b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
							s.parentNode.insertBefore(b, s);})(window.lintrk);
					`}
				</script>
				<noscript>
					{`
						<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=10534169&fmt=gif" />
					`}
				</noscript>
			</Helmet>
			<Header />
			{children}
			{title !== "Contact" && <Footer page={page} />}
			<CookieConsent
				buttonText={cookieButtonText}
				cookieName="gatsby-gdpr-google-tagmanager"
				onAccept={() => {
					initializeAndTrack(location);
				}}
				disableStyles={true}
				buttonClasses="px-4 py-1 border-white border-2 border-opacity-10 rounded-lg mr-4 transition duration-200 hover-hover:hover:bg-white hover-hover:hover:text-purple"
				declineButtonClasses="px-4 py-1 border-white border-2 border-opacity-10 rounded-lg transition duration-200 hover-hover:hover:bg-white hover-hover:hover:text-purple"
				containerClasses="fixed bottom-0 z-50 w-full py-8 px-16 bg-purple bg-opacity-90 backdrop-filter backdrop-blur-md text-white flex flex-col gap-6 md:flex-row justify-between items-center"
				contentClasses="text-lg md:text-xl text-center md:text-left"
			>
				<div dangerouslySetInnerHTML={{ __html: cookieText }}></div>
			</CookieConsent>
		</>
	);
};

export default Layout;
